import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.page.share');
import { HostListener, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-page-share',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.page.share/view.scss */
:host {
  display: block;
}

.share-bar {
  background: white;
  border-bottom: 1px solid #e5e7eb;
  padding: 12px 24px;
  color: #374151;
  font-size: 13px;
}

.share-summary, .actions, .invitation, .member {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.share-toolbar-actions > button, .share-toolbar-actions > a {
  margin-left: auto;
}

.share-label {
  font-weight: 600;
}

.share-summary .share-trigger {
  position: relative;
  display: inline-flex;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 9999px;
  background: #f97316;
  color: white;
  box-shadow: 0 4px 10px rgba(249, 115, 22, 0.24);
  transition: background-color 0.15s ease, transform 0.15s ease;
}

.share-summary .share-trigger:hover {
  background: #ea580c;
  transform: translateY(-1px);
}

.share-summary .share-trigger:focus-visible {
  outline: 3px solid rgba(249, 115, 22, 0.35);
  outline-offset: 2px;
}

.share-trigger svg {
  width: 20px;
  height: 20px;
}

.invite-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  display: flex;
  min-width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  border: 2px solid white;
  border-radius: 9999px;
  background: #dc2626;
  color: white;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
}

.share-panel {
  max-width: 850px;
  margin: 20px auto;
  padding: 22px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fafafa;
}

header > button {
  flex-shrink: 0;
  white-space: nowrap;
  align-self: flex-start;
}

header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

h2 {
  font-size: 17px;
  font-weight: 600;
}

h3 {
  font-weight: 600;
  margin: 18px 0 10px;
}

p {
  margin: 8px 0;
  color: #6b7280;
}

button, a {
  border-radius: 6px;
  padding: 7px 10px;
  color: #4f46e5;
  background: #eef2ff;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

button.primary {
  background: #4f46e5;
  color: white;
}

input, select, textarea {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 8px;
  background: white;
  min-width: 0;
}

textarea {
  width: 100%;
  margin-bottom: 10px;
}

.invite-form {
  display: grid;
  gap: 8px;
}

.member {
  margin: 10px 0;
}

.member input {
  flex: 1;
}

.share-message {
  color: #4f46e5;
  overflow-wrap: anywhere;
}

.shared-link {
  margin: 4px;
}

@media (max-width: 600px) {
  .share-bar {
    padding: 12px 16px;
  }
  .share-summary {
    padding-left: 36px;
  }
  .share-panel {
    padding: 14px;
  }
  .member input {
    flex-basis: 100%;
  }
}
.share-summary .delete-trigger {
  margin-left: auto;
  color: #dc2626;
  background: #fef2f2;
}

.share-summary .delete-trigger + .share-trigger {
  margin-left: 0;
}

.capstone-switch {
  display: flex;
  align-items: center;
  gap: 8px;
}

.capstone-switch > button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 50%;
  background: #fff;
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
}

.capstone-switch > button[aria-selected=true] {
  border-color: #f97316;
  background: #f97316;
  color: #fff;
}

.capstone-switch > button:hover {
  border-color: #f97316;
}

.capstone-switch > button:focus-visible {
  outline: 3px solid rgba(249, 115, 22, 0.35);
  outline-offset: 2px;
}

.share-context, .share-toolbar-actions {
  display: contents;
}

.capstone-bar .share-summary {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 16px;
  padding-left: 0;
}
.capstone-bar .share-context {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.capstone-bar .share-context > span {
  white-space: nowrap;
}
.capstone-bar .share-label {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.capstone-bar .capstone-switch {
  flex-shrink: 0;
}
.capstone-bar .share-toolbar-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 10px;
}
.capstone-bar .share-toolbar-actions > button {
  margin-left: 0;
}

@media (max-width: 600px) {
  .capstone-bar .share-summary {
    flex-wrap: wrap;
    gap: 12px;
  }
  .capstone-bar .share-context {
    width: 100%;
    gap: 8px;
  }
  .capstone-bar .share-toolbar-actions {
    margin-left: auto;
  }
  .capstone-bar .share-label {
    max-width: 150px;
  }
}
.capstone-bar .expand-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 50%;
  background: white;
  color: #374151;
  font-size: 20px;
}

.capstone-bar .expand-trigger[aria-pressed=true] {
  background: #fff0eb;
  border-color: #f97316;
  color: #ea580c;
}

.capstone-bar .expand-trigger:focus-visible {
  outline: 3px solid rgba(249, 115, 22, 0.35);
  outline-offset: 2px;
}

.public-training-share {
  padding-bottom: 18px;
  border-bottom: 1px solid #e5e7eb;
}

.public-training-share input {
  width: 100%;
  margin-top: 12px;
  font-size: 12px;
}

.bike-html-share {
  padding-bottom: 18px;
  border-bottom: 1px solid #e5e7eb;
}`],
})
export class ComponentPageShareComponent implements OnInit, OnDestroy {
    public page: any = null;
    public lists: any = { owned: [], shared: [], invites: [] };
    public message = '';
    public open = false;
    public busy = false;
    public friend = '';
    public role = 'editor';
    public duty = '';
    public note = '';
    public supported = false;
    public isCapstone = false;
    public isBikeLink = false;
    public noteExpanded = false;
    public capstoneSection = 'description';
    public publicTrainingUrl = location.origin + '/assets/oral-training/index.html#/training';
    private subscription: any;
    private generation = 0;
    private readonly noteExpansionStorageKey = 'ku-capstone-note-expanded';
    private readonly bikeExpansionStorageKey = 'ku-bike-link-expanded';
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {}
    async ngOnInit() {
        await this.service.init();
        this.subscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) { this.open = false; void this.load(); }
        });
        await this.load();
    }
    setNoteExpansion(expanded: boolean, persist = true) {
        this.noteExpanded = expanded;
        if (persist && (this.isCapstone || this.isBikeLink)) {
            const key = this.isCapstone ? this.noteExpansionStorageKey : this.bikeExpansionStorageKey;
            try { localStorage.setItem(key, String(expanded)); } catch {}
        }
        window.dispatchEvent(new CustomEvent('ku-note-expansion', { detail: expanded }));
    }
    restoreNoteExpansion() {
        if (!this.isCapstone && !this.isBikeLink) {
            this.setNoteExpansion(false, false);
            return;
        }
        const key = this.isCapstone ? this.noteExpansionStorageKey : this.bikeExpansionStorageKey;
        let expanded = false;
        try { expanded = localStorage.getItem(key) === 'true'; } catch {}
        this.setNoteExpansion(expanded, false);
    }
    async toggleNoteExpansion() {
        this.setNoteExpansion(!this.noteExpanded);
        await this.service.render();
    }
    @HostListener('document:keydown.escape')
    async closeNoteExpansion() {
        if (!this.noteExpanded) return;
        this.setNoteExpansion(false);
        await this.service.render();
    }
    setCapstoneSection(section: string, event?: KeyboardEvent) {
        event?.preventDefault();
        if (section !== 'description' && section !== 'implementation') return;
        void this.router.navigate([], { queryParams: { section }, queryParamsHandling: 'merge', replaceUrl: true });
        this.capstoneSection = section;
        window.dispatchEvent(new CustomEvent('ku-capstone-section', { detail: section }));
        if (event) document.getElementById('capstone-tab-' + section)?.focus();
    }
    async request(action: string, data: any = {}) {
        const res: any = await wiz.call('handle', { action, data: JSON.stringify(data) });
        if (res.code !== 200) throw new Error(res.data?.message || res.message || '요청을 처리하지 못했습니다.');
        return res.data;
    }
    async load() {
        const generation = ++this.generation;
        const path = location.pathname;
        this.isCapstone = path === '/capstone';
        this.isBikeLink = path === '/course/aafa5691f92f40e89818200a14c98a90';
        this.restoreNoteExpansion();
        this.capstoneSection = this.isCapstone && new URLSearchParams(location.search).get('section') === 'implementation' ? 'implementation' : 'description';
        this.supported = ['/algorithm', '/algorithm/run', '/capstone'].includes(path) || path.startsWith('/course/');
        this.page = null; this.message = ''; this.note = '';
        if (!this.service.auth.status) { await this.service.render(); return; }
        try {
            const lists = await this.request('list');
            const page = this.supported ? await this.request('get', {path, id: new URLSearchParams(location.search).get('share') || ''}) : null;
            if (generation !== this.generation) return;
            this.lists = lists; this.page = page; this.note = page?.note || '';
        } catch (error: any) { if (generation === this.generation) this.message = error.message; }
        await this.service.render();
    }
    async perform(action: string, extra: any = {}) {
        if (this.busy) return;
        this.busy = true; this.message = '';
        try {
            const data = await this.request(action, { id: this.page?.id, path: this.page?.path, ...extra });
            if (['accept', 'decline', 'leave'].includes(action)) {
                if (action === 'leave') this.service.href('/dashboard');
                await this.load();
            } else { this.page = data; this.note = data.note; }
            this.message = action === 'invite' ? '초대를 보냈어요. 친구가 로그인 후 수락하면 공유됩니다.' : '반영했어요.';
            if (action === 'invite') { this.friend = ''; this.duty = ''; }
            window.dispatchEvent(new Event('ku-courses-changed'));
        } catch (error: any) { this.message = error.message; }
        finally { this.busy = false; await this.service.render(); }
    }
    async deletePage() {
        if (this.busy || this.page?.role !== 'owner') return;
        this.busy = true;
        this.message = '';
        const page = this.page;
        try {
            await this.request('delete', { id: page.id, path: page.path });
            this.generation++;
            this.page = null;
            this.open = false;
            window.dispatchEvent(new Event('ku-courses-changed'));
            this.service.href('/dashboard');
        } catch (error: any) { this.message = error.message; }
        finally { this.busy = false; await this.service.render(); }
    }
    async shareBikeHtml() {
        if (!this.isBikeLink) return;
        const source = document.querySelector('.bike-page') as HTMLElement | null;
        if (!source) {
            this.message = '분석 화면을 찾지 못했습니다.';
            await this.service.render();
            return;
        }
        const snapshot = source.cloneNode(true) as HTMLElement;
        const originals = [source, ...Array.from(source.querySelectorAll('*'))];
        const copies = [snapshot, ...Array.from(snapshot.querySelectorAll('*'))];
        for (let index = 0; index < originals.length; index++) {
            const original = originals[index] as HTMLElement;
            const copy = copies[index] as HTMLElement;
            const computed = getComputedStyle(original);
            const declarations: string[] = [];
            for (let property = 0; property < computed.length; property++) {
                const name = computed.item(property);
                if (name.startsWith('--') || name.startsWith('-webkit-') || /^(animation|transition|cursor|pointer-events)/.test(name)) continue;
                declarations.push(name + ':' + computed.getPropertyValue(name));
            }
            copy.setAttribute('style', declarations.join(';'));
            for (const attribute of Array.from(copy.attributes)) {
                if (/^on/i.test(attribute.name)) copy.removeAttribute(attribute.name);
            }
            if (original instanceof HTMLInputElement && copy instanceof HTMLInputElement) {
                copy.setAttribute('value', original.value);
                copy.disabled = true;
            }
            if (original instanceof HTMLSelectElement && copy instanceof HTMLSelectElement) {
                Array.from(copy.options).forEach((option, optionIndex) => {
                    option.selected = optionIndex === original.selectedIndex;
                });
                copy.disabled = true;
            }
            if (original instanceof HTMLTextAreaElement && copy instanceof HTMLTextAreaElement) {
                copy.textContent = original.value;
                copy.disabled = true;
            }
        }
        snapshot.querySelectorAll('script, iframe').forEach(element => element.remove());
        const tab = source.querySelector('.bike-nav button.active')?.textContent?.trim() || '분석';
        const title = '빅데이터개론 · ' + tab;
        const escapedTitle = title.replace(/[&<>"]/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[character] || character));
        const html = '<!doctype html><html lang="ko"><head><meta charset="utf-8">' +
            '<meta http-equiv="Content-Security-Policy" content="default-src \'none\'; style-src \'unsafe-inline\'; img-src data:; font-src data:">' +
            '<meta name="viewport" content="width=device-width,initial-scale=1">' +
            '<title>' + escapedTitle + '</title></head><body style="margin:0;background:#f3f7fb">' +
            '<p style="margin:0;padding:12px 24px;background:#fff3e8;color:#60350e;font:14px sans-serif">' +
            '빅데이터개론 · ' + escapedTitle + ' 화면을 저장한 정적 HTML입니다. 버튼과 데이터 조회는 동작하지 않습니다.</p>' +
            snapshot.outerHTML + '</body></html>';
        const file = new File([html], 'bike-link-analysis.html', {type: 'text/html;charset=utf-8'});
        const sharing: any = navigator;
        try {
            if (sharing.share && sharing.canShare?.({files: [file]})) {
                await sharing.share({files: [file], title});
                this.message = '현재 분석 화면의 HTML 파일을 공유했습니다.';
            } else {
                const url = URL.createObjectURL(file);
                const link = document.createElement('a');
                link.href = url;
                link.download = file.name;
                link.click();
                setTimeout(() => URL.revokeObjectURL(url), 60000);
                this.message = '현재 분석 화면의 HTML 파일을 다운로드했습니다.';
            }
        } catch (error: any) {
            this.message = error?.name === 'AbortError' ? 'HTML 공유를 취소했습니다.' : 'HTML 공유에 실패했습니다.';
        }
        await this.service.render();
    }
    async copyPublicLink() {
        try {
            await navigator.clipboard.writeText(this.publicTrainingUrl);
            this.message = '훈련 HTML 링크를 복사했어요. 로그인이나 친구 수락 없이 열 수 있어요.';
        } catch { this.message = '훈련 HTML 링크: ' + this.publicTrainingUrl; }
        await this.service.render();
    }
    async copyLink() {
        if (!this.page) return;
        const url = location.origin + this.page.path + '?share=' + this.page.id;
        try { await navigator.clipboard.writeText(url); this.message = '링크를 복사했어요. 수락한 친구만 열 수 있어요.'; }
        catch { this.message = '공유 링크: ' + url; }
        await this.service.render();
    }
    go(page: any) { location.assign(page.path + '?share=' + page.id); }
    async toggle() { this.open = !this.open; await this.service.render(); }
    ngOnDestroy() { this.setNoteExpansion(false, false); this.generation++; this.subscription?.unsubscribe(); }
}

export default ComponentPageShareComponent;